import { Fade, IconButton } from "@mui/material";
import { useMemo, useState } from "react";
import { classes } from "../../../utils/styles";
import { NetworkIcon } from "../../Icons";
import { useRouting } from "./RoutingContext";
import styles from "./routing-node-wrapper.module.scss";

interface RoudeNodeWrapperProps {
  nodeType: "source" | "destination" | "processor";
  index: number;
  componentPath?: string;
}

export const RoutingNodeWrapper: React.FC<RoudeNodeWrapperProps> = ({
  children,
  nodeType,
  index,
  componentPath,
}) => {
  const [hovered, setHovered] = useState(false);

  const {
    connectableComponentPaths,
    onConnect: connectComponentRoute,
    onRouteMenuOpen: onRouteMenuClick,
    readOnly,
  } = useRouting();

  const connectable = useMemo(
    () => componentPath && connectableComponentPaths.includes(componentPath),
    [componentPath, connectableComponentPaths],
  );

  const classNames = [styles.container];
  if (connectable) {
    classNames.push(styles.highlighted);
  }
  function handleConnectClick(e: React.MouseEvent<HTMLDivElement, MouseEvent>) {
    if (!connectable) {
      return;
    }
    connectComponentRoute(componentPath!);
  }

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={handleConnectClick}
      className={classes(classNames)}
    >
      {children}
      {nodeType === "source" && (
        <Fade in={hovered && !readOnly}>
          <IconButton
            classes={{ root: styles.btn }}
            onClick={(e) => onRouteMenuClick(e, nodeType, index)}
          >
            <NetworkIcon width="15px" height="15px" />
          </IconButton>
        </Fade>
      )}
    </div>
  );
};
